/**
 * number 또는 number[]을 입력값으로 요일 텍스트를 반환
 *
 * ex. [0,2,3] -> "월, 수, 목"
 */
export function getDayOfWeek(value: number | number[]): string {
  const weekDay = ['일', '월', '화', '수', '목', '금', '토'];

  if (typeof value === 'number') {
    return weekDay[value];
  }

  return value.sort().reduce((prev, current) => {
    if (!prev) {
      return weekDay[current];
    }

    return `${prev}, ${weekDay[current]}`;
  }, '');
}
